<template>
    <form ref="form" method="POST" :action="confirmation.url">
        <input type="hidden" name="_token" :value="csrfToken">
        <input type="hidden" name="ignoreWarning" value="1">
    </form>
</template>

<script>
import DialogManager from '../services/DialogManager';

export default {
    props: {
        confirmation: {
            type: Object,
            required: true,
        },
    },

    computed: {
        csrfToken() {
            return document.head.querySelector('meta[name="csrf-token"]')?.content || '';
        },
    },

    mounted() {
        DialogManager.confirm(this.confirmation.message)
            .then(() => {
                this.$refs.form.submit();
            })
            .catch(() => {});
    },
};
</script>
